(function () {
    "use strict";

    var module = angular.module("uwAgenda.settings.agendasettings");
    module.controller("AgendaSettingsGeneralController", [
        "$scope",
        "$state",
        "$stateParams",
        "$filter",
        "$translate",
        "$localStorage",
        "$timeout",
        "Alert",
        "WebAppViewTypeEnum",
        "AppointmentShowEnum",
        "OnlineLoginType",
        "agenda",
        "agendaLabels",
        "AgendaService",
        "Agenda",
        "AgendaTranslation",
        "languages",
        "Weekday",
        "HelperService",
        "RecurrenceConflictOption",
        "SharedAgendaBroadcast",
        "OnlineMailConfirmationOption",
        '$uibModal',
        'ResourcesService',
        'ContactInfoService',
        'SharedAgendaService',
        'agendaAppointmentTypes',
        AgendaSettingsGeneralControllerFn
    ]);

    /* controlle for main agenda-settings */
    function AgendaSettingsGeneralControllerFn(
        $scope,
        $state,
        $stateParams,
        $filter,
        $translate,
        $localStorage,
        $timeout,
        Alert,
        WebAppViewTypeEnum,
        AppointmentShowEnum,
        OnlineLoginType,
        agenda,
        agendaLabels,
        AgendaService,
        Agenda,
        AgendaTranslation,
        languages,
        Weekday,
        HelperService,
        RecurrenceConflictOption,
        SharedAgendaBroadcast,
        OnlineMailConfirmationOption,
        $uibModal,
        ResourcesService,
        ContactInfoService,
        SharedAgendaService,
        agendaAppointmentTypes
    ) {
        var vm = this;
        //selected agenda
        vm.agenda = {};
        //list of webapp view types (day, week...)
        vm.webAppViewTypes = {};
        // list of possible login-views
        vm.loginViews = {};
        //list of limits for showing appointments (none, realtime...)
        vm.appointmentShowLimits = {};
        //list of all agenda intervals
        vm.agendaIntervals = [];
        vm.maxDurations = [];
        //list of agenda labels for selected agenda
        vm.agendaLabels = [];
        //list of all languages
        vm.languages = [];
        // model of fields to translate
        vm.agendaTranslationPrototype = {};
        //list of all weekdays
        vm.weekdays = [];
        // list of contactinfotypes
        vm.contactinfotypes = [];
        // list of recurrence conflict options
        vm.recurrenceConflictOptions = {};

        vm.selectedLanguage = null;

        // list of MailTo Enum options
        vm.onlineMailConfirmationOptions = {};
        

        vm.agendaTranslationFields = [
            'confirmationEmailText',
            'confirmationEmailForClientText',
            'confirmationEmailForClientSubject',
            'confirmationSMSText',
            'reminderSMSText',
            'noNewPatientsAllowedPopupText',
            'noNewPatientsAllowedPopupConfirmationText',
            'everydayPatientInformation',
            'mandatoryTextInAppointment',
            'onlinePatientInformation',
            'onlineRepresentativesInformation',
            'weekdayPatientInformation',
            'weekendPatientInformation',
            'appointmentMemoCaption',
            'appointmentUserDataCaption',
        ];

        vm.agendaTranslationFieldsWithDefaultText = [
            'confirmationEmailText',
            'confirmationEmailForClientText',
            'confirmationEmailForClientSubject',
            'confirmationSMSText',
            'reminderSMSText',
            'noNewPatientsAllowedPopupText',
            'noNewPatientsAllowedPopupConfirmationText',
            'videoConsultPatientConfirmationEmailText',
            'videoConsultClientConfirmationEmailText',
        ];

        activate();

        // show videoconsults textfields
        if (vm.agenda.videoconsultsActivated)
        {
            vm.agendaTranslationFields.push("videoConsultPatientConfirmationEmailText");
            vm.agendaTranslationFields.push("videoConsultClientConfirmationEmailText");
        }
        
        vm.selectInterval = function (interval) {
            vm.agenda.interval = interval;
            generateMaxDurations(vm.agenda.interval);
        };

        vm.selectMaxDuration = function (maxDuration) {
            vm.agenda.maxDuration = maxDuration;
        };

        // Synchronize Agenda-Reminder-Settings (Mails,SMS)
        vm.synchronize = function () {
            AgendaService.synchronize(vm.agenda.id).then(function (result) {
                Alert.success("Synchronization finished");
            });
        };

        vm.hasDefaultText = function (field) {
            return vm.agendaTranslationFieldsWithDefaultText.indexOf(field) > -1;
        }

        vm.editAgendaTranslation = function (translation, field) {
            var text = translation[field];
            var hasDefaultText = vm.agendaTranslationFieldsWithDefaultText.indexOf(field) > -1;

            if (hasDefaultText) {
                // load default agenda translation text
                ResourcesService.getDefaultAgendaText(field, translation.fK_Language)
                    .then(function (defaultText) {
                        openEditTranslationModal(translation, field, text, defaultText);
                    });
            } else {
                openEditTranslationModal(translation, field, text, '');
            }
        };
        

        vm.saveActiveTab = function (tabName) {
            $localStorage.activeSettingsTab = tabName;
        };

        function openEditTranslationModal(translation, field, text, defaultText) {
            // open modal with summernote
            var modalInstance = $uibModal.open({
                backdrop: "static",
                keyboard: false,
                animation: true,
                templateUrl:
                    "/app/global/templates/rf-global-summernote-modal.template.html",
                controller: "SummernoteModalController",
                controllerAs: "vm",
                size: "md",
                resolve: {
                    modalData: function () {
                        return {
                            title: field,
                            content: text,
                            defaultContent: defaultText,
                            showResetButton: !!defaultText
                        };
                    }
                }
            });

            // update field content when modal is closed
            modalInstance.result.then(function (editedContent) {
                translation[field] = editedContent;
                // save settings immediately
                vm.save();
            });
        }

        vm.getTranslatedLanguageName = function () {
            return $translate.instant('language_' + vm.selectedLanguage.id);
        };


        vm.addTranslation = function (language) {

            var translation = new AgendaTranslation();
            translation.language = language;
            translation.fK_Language = language.id;

            vm.agenda.translations.push(translation);

            setLanguages();
        };

        vm.selectLanguage = function (language) {
            vm.selectedLanguage = language;
        };

        // save
        vm.save = function () {
            if(vm.agenda.webAppPrimaryColor){
                // Save the original color in local storage so that it will not get overriden after saving and refreshing
                vm.agenda.webAppPrimaryColor = calculateBrigntnessOfAColor(vm.agenda.webAppPrimaryColor);
            }
            // new object for save
            vm.agenda.prepareForSave();
            
            if (vm.agenda.loginView === 0) {
                Alert.error('You have to select a way to login online!');
                return;
            }

            if (vm.agenda.id) {
                //update
                AgendaService.update(vm.agenda.id, vm.agenda).then(
                    function (updatedAgenda) {
                        vm.agenda.extend(updatedAgenda);
                        Alert.success($translate.instant('agenda_settings_saved'));
                    },
                    function () {
                        vm.agenda.extend(agenda); // restore delete vm-properties
                    }
                );
            } // if
            else {
                //agenda is created automatically in backend
                Alert.danger("Creating a new agenda is not allowed!");
                return;
            } // else
        }; // save

        // abort
        vm.abort = function () {
            // reload
            $state.go($state.current, {}, {reload: $state.current.name});
        };

        function generateIntervals() {
            vm.agendaIntervals = [];
            for (let i = 1; i < 5; i++) {
                vm.agendaIntervals.push(i);
            }
            for (let i = 5; i <= 60; i = i + 5) {
                vm.agendaIntervals.push(i);
            }
        }

        function generateMaxDurations(interval) {
            vm.maxDurations = [];
            for (var duration = 0; duration <= 180; duration = duration + interval) {
                vm.maxDurations.push(duration);
            }
        }

        function setLanguages() {
            // try to set current language of user as first entry
            // is current language of owner already set?
            let indexOfCurrentLanguage = -1;
            for(let i=0; i<languages.length; i++)
                if(languages[i].id === $localStorage.CurrentLanguage.id) {
                    indexOfCurrentLanguage = i;
                    break;
                }
            if (indexOfCurrentLanguage !== -1) {
                const language = languages[indexOfCurrentLanguage];
                // remove from array and add at beginning of the array
                languages.splice(indexOfCurrentLanguage, 1);
                languages.splice(0, 0, language);
            }
            // filter out already used languages in dropdown
            let languagesInUse = vm.agenda.translations.map(tr => tr.fK_Language);
            vm.languages = languages.filter(lang => languagesInUse.indexOf(lang.id) === -1);

            let owner = SharedAgendaService.currentUser();
            const agendaOwnerLanguageIndex = vm.languages.findIndex(language => language.id === owner.languageId);

            vm.selectedLanguage = vm.languages.length > 0 ? vm.languages[0] : null;
            formatLanguagesInDropdown (agendaOwnerLanguageIndex);
            
        }
        
        function formatLanguagesInDropdown (agendaOwnerLanguageIndex){
            if (agendaOwnerLanguageIndex !== -1) {
                const [agendaOwnerLanguage] = vm.languages.splice(agendaOwnerLanguageIndex, 1);
                vm.languages.unshift(agendaOwnerLanguage);
            }
        }
        
        //Calculate the brightness of a color and set it to black if it is too bright
        function calculateBrigntnessOfAColor(hex) {
            //Convert the value of the webappColor from hex to rgb
            hex = hex.replace('#', '');
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);
            //Calculate the hsp value
            const hsp = Math.sqrt(0.299*Math.pow(r,2) + 0.715*Math.pow(g,2) + 0.072*Math.pow(b,2));
            //Set the color to black if the color is too bright
            return hsp > 230 ? '#000000' : `#${hex}`;
        }
        

        /* activation work */
        function activate() {
            //check if user has access to selected agenda or if selected user has an agenda at all (only mainuser + ringfoon admin)
            if (agenda === null || typeof agenda === "undefined") {
                Alert.danger("User has no agenda, check rights configuration!");
                return;
            }

            if (!agenda.webAppPrimaryColor) {
                $timeout(function () {
                    $("#webAppPrimaryColor").val("#1ABB9C");
                });
            }

            // set agenda
            vm.agenda = new Agenda();
            vm.agenda.extend(agenda);

            // lists
            vm.agendaLabels = agendaLabels;

            vm.agendaAppointmentTypes = agendaAppointmentTypes;
            if (agendaAppointmentTypes && vm.agenda.fK_DefaultAppointmentType) {
                vm.agendaDefaultAppointmentType = agendaAppointmentTypes.filter(
                    at => at.id === vm.agenda.fK_DefaultAppointmentType
                )[0];
            }
            vm.onAppointmentTypeChanged = type => {
                vm.agenda.fK_DefaultAppointmentType = type.id;
            };

            setLanguages();

            // set correct cancelbufferlabel (agendalabel)
            if (
                typeof vm.agenda.fK_CancelBufferLabel !== "undefined" &&
                vm.agenda.fK_CancelBufferLabel !== null
            ) {
                vm.agenda.cancelBufferLabel = $filter("filter")(
                    vm.agendaLabels,
                    {id: vm.agenda.fK_CancelBufferLabel},
                    true
                )[0];
            }

            // put weekdays without holiday
            vm.weekdays.push(Weekday.Monday);
            vm.weekdays.push(Weekday.Tuesday);
            vm.weekdays.push(Weekday.Wednesday);
            vm.weekdays.push(Weekday.Thursday);
            vm.weekdays.push(Weekday.Friday);
            vm.weekdays.push(Weekday.Saturday);
            vm.weekdays.push(Weekday.Sunday);

            vm.recurrenceConflictOptions = RecurrenceConflictOption;
            vm.webAppViewTypes = WebAppViewTypeEnum;
            vm.appointmentShowLimits = AppointmentShowEnum;
            vm.loginViews = OnlineLoginType;
            vm.onlineMailConfirmationOptions = OnlineMailConfirmationOption;
            vm.contactinfotypes = ContactInfoService.data.contactinfotypes;

            // create prototype for agenda translation row
            vm.agendaTranslationPrototype = new AgendaTranslation();

            generateIntervals();
            generateMaxDurations(vm.agenda.interval);

            // listen
            listen();

            // clear
            agenda = null;
            agendaLabels = null;
            
            //set correct tab form localstorage (after refresh)
            let activeTab = "#tab_settings";
            if ($localStorage.activeSettingsTab)
            {
                activeTab = $localStorage.activeSettingsTab;
            }
            let elementName = '[data-target="'+ activeTab + '"]';
            angular.element(elementName).tab('show');


        } // activate

        // listen
        function listen() {
            let listener = $scope.$on(SharedAgendaBroadcast.UpdateUI, function () {
                $state.go($state.current, {}, {reload: $state.current.name});
            });
            // destroy
            $scope.$on("$destroy", function () {
                listener();
                listener = null;
            });
        } // listen
    }
})();
